var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 192 192",
    height: 192,
    viewBox: "0 0 192 192",
    width: 192,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 192,
    width: 192
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "136,56 100,52 56,56 52,96 56,136 96,141 136,136 140,95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.41,118.06c-2.99-2.02-5.06-4.97-6.19-8.87l6.94-2.86c0.63,2.4,1.73,4.26,3.3,5.58 c1.56,1.32,3.46,1.97,5.68,1.97c2.27,0,4.22-0.69,5.85-2.07c1.63-1.38,2.45-3.14,2.45-5.27c0-2.18-0.86-3.96-2.58-5.34 s-3.88-2.07-6.46-2.07h-4.01v-6.87h3.6c2.22,0,4.09-0.6,5.61-1.8c1.52-1.2,2.28-2.84,2.28-4.93c0-1.86-0.68-3.34-2.04-4.45 c-1.36-1.11-3.08-1.67-5.17-1.67c-2.04,0-3.66,0.54-4.86,1.63s-2.07,2.43-2.62,4.01l-6.87-2.86c0.91-2.58,2.58-4.86,5.03-6.83 c2.45-1.97,5.58-2.96,9.38-2.96c2.81,0,5.34,0.54,7.58,1.63c2.24,1.09,4,2.6,5.27,4.52c1.27,1.93,1.9,4.09,1.9,6.49 c0,2.45-0.59,4.52-1.77,6.22c-1.18,1.7-2.63,3-4.35,3.91v0.41c2.27,0.95,4.12,2.4,5.58,4.35c1.45,1.95,2.18,4.28,2.18,7 c0,2.72-0.69,5.15-2.07,7.28c-1.38,2.13-3.29,3.81-5.71,5.03c-2.43,1.22-5.16,1.84-8.19,1.84 C78.64,121.09,75.4,120.08,72.41,118.06z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,83.62l-7.58,5.51l-3.81-5.78l13.67-9.86h5.24V120H115V83.62z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EA4335",
    points: "136,172 172,136 154,128 136,136 128,154"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#34A853",
    points: "48,154 56,172 136,172 136,136 56,136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,20c-6.63,0-12,5.37-12,12v104l18,8l18-8V56h80l8-18l-8-18H32z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,136v24c0,6.63,5.37,12,12,12h24v-36H20z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBBC04",
    points: "136,56 136,136 172,136 172,56 154,48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,56V32c0-6.63-5.37-12-12-12h-24v36H172z",
    fill: "#1967D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google_calendar.b934d886e00beeef9e948ec1fee851e8.svg";
export { ForwardRef as ReactComponent };